import React, { useEffect, useState } from "react";
import ItemShops from "../components/ItemShops";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import FilterBar from "../components/FilterBar";
import { useNavigate } from "react-router-dom";
import { get, query as dbQuery, orderByChild, limitToLast, ref } from "firebase/database";
import ItemShopShimmer from "../components/home/ItemShopShimmer";
import { database } from "../firebase/firebaseConfig";
import { useSearchParams } from "react-router-dom";
import QuickContactDialog from "../components/home/QuickContactDialog";
import ShopDetailsModal from "../components/home/ShopDetailsModal";


function SecretMarketPlace() {
    const [isQuickContactOpen, setIsQuickContactOpen] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedShop, setSelectedShop] = useState(null);
    const [query, setQuery] = useState("");
    const [activeFilter, setActiveFilter] = useState("all");
    const [areaQuery, setAreaQuery] = useState("");
    const [shops, setShops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredShops, setFilteredShops] = useState([]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const fullAddress = selectedShop?.address
        ? `${selectedShop.address.city || ""}, ${selectedShop.address.province || ""}`.replace(", ,", ",")
        : "No Address Provided";


    useEffect(() => {
        const urlFilter = searchParams.get("filter");

        if (urlFilter) {
            setActiveFilter(urlFilter);
        }
    }, [searchParams]);

    const handleShopClick = (shop) => {
        setSelectedShop(shop);
    }

    const openQuickContact = (shop) => {
        setIsQuickContactOpen(true);
        setSelectedShop(shop);
    }

    const closeQuickContact = () => {
        setIsQuickContactOpen(false);
    }
    const openMoreInfo = (shop) => {
        setSelectedShop(shop);
        setShowDetails(true);
    };

    const closeMoreInfo = () => {
        setShowDetails(false);
        setSelectedShop(null);
    }




    useEffect(() => {
        const fetchShops = async () => {
            try {
                setLoading(true);

                const usersRef = dbQuery(
                    ref(database, "PublicStores"),
                    orderByChild("createdAt"),
                    limitToLast(20) // get latest users first
                );

                const snapshot = await get(usersRef);

                if (!snapshot.exists()) {
                    setShops([]);
                    return;
                }

                const data = snapshot.val();


                const shopsList = Object.values(data)
                    // PublicStores is written only by the server for approved
                    // listings. The missing-status branch keeps pre-migration
                    // approved projections visible until the next rebuild.
                    .filter((user) => user.type !== "admin" && (user.status === "approved" || !user.status))
                    .sort((a, b) => b.createdAt - a.createdAt);

                setShops(shopsList);

            } catch (error) {
                console.error("Error fetching shops:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchShops();
    }, []);

    useEffect(() => {
        setFilteredShops(shops);
    }, [shops]);

    useEffect(() => {
        let result = [...shops];

        // 🏷 Shop type filter
        if (activeFilter !== "all") {
            result = result.filter((shop) => {
                if (activeFilter === "printShop") return shop.type === "printShop";
                if (activeFilter === "specialist") return shop.type === "specialist";
                if (activeFilter === "supplier") return shop.type === "supplier";
                return true;
            });
        }

        // 📍 Area filter
        if (areaQuery.trim()) {
            const area = areaQuery.trim().toLowerCase();

            result = result.filter((shop) => {
                const address = shop.address
                    ? `${shop.address.street || ""} ${shop.address.city || ""} ${shop.address.province || ""} ${shop.address.postalCode || ""}`.toLowerCase()
                    : "";

                return address.includes(area);
            });
        }

        // 🔍 Search filter (search everything in ONE filter)
        if (query.trim()) {
            const search = query.trim().toLowerCase();

            result = result.filter((shop) => {
                const shopName = (shop.shopName || "").toLowerCase();

                const address = shop.address
                    ? `${shop.address.street || ""} ${shop.address.city || ""} ${shop.address.province || ""} ${shop.address.postalCode || ""}`.toLowerCase()
                    : "";

                const selectedSupplies = Array.isArray(shop.selectedSupplies)
                    ? shop.selectedSupplies.join(" ").toLowerCase()
                    : "";

                const customSupplies = Array.isArray(shop.customSupplies)
                    ? shop.customSupplies.join(" ").toLowerCase()
                    : "";

                const type = (shop.type || "").toLowerCase();

                const description = (shop.description || "").toLowerCase();

                return (
                    shopName.includes(search) ||
                    address.includes(search) ||
                    type.includes(search) ||
                    description.includes(search) ||
                    selectedSupplies.includes(search) ||
                    customSupplies.includes(search)
                );
            });
        }

        setFilteredShops(result);
    }, [shops, query, activeFilter, areaQuery]);

    return (
        <div className="bg-background min-h-full flex flex-col font-['Plus_Jakarta_Sans',sans-serif]">
            <NavBar />
            <section className="max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[32px] md:py-[48px] flex flex-col gap-[24px]">
                <a class="inline-flex items-center gap-[6px] font-semibold text-[13px] text-[#717182] hover:text-[#212326] transition-colors no-underline self-start" href="/" data-discover="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left w-[14px] h-[14px]">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                    Back to Home
                </a>
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-[12px]">
                    <div>
                        <h2 className="font-semibold text-[26px] md:text-[32px] text-[#212326] mb-[4px]">Marketplace</h2>
                        <p className="font-medium text-[14px] text-[#717182]">
                            {filteredShops.length} businesses available
                        </p>
                    </div>
                    <div className="relative w-full md:w-[340px]">
                        <input
                            type="text"
                            placeholder="Search shops, suppliers, services..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            className="w-full h-[44px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-medium text-[16px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] bg-white transition-colors"
                        />

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]">
                            <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path>
                        </svg>
                    </div>
                </div>
                <FilterBar
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                    areaQuery={areaQuery}
                    setAreaQuery={setAreaQuery}
                />
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px]">
                    {loading ? (
                        [...Array(6)].map((_, index) => (
                            <ItemShopShimmer index={index} />
                        ))
                    ) : (
                        filteredShops.map((shop, index) => (
                            <ItemShops
                                shop={shop}
                                index={index}
                                openQuickContact={openQuickContact}
                                cardType="Marketplace"
                                handleShopClick={handleShopClick}
                                selectedShop={selectedShop}
                                navigate={navigate}
                                openMoreInfo={openMoreInfo}
                            />
                        ))
                    )}
                </div>

                {isQuickContactOpen && (
                    <QuickContactDialog
                        shop={selectedShop}
                        onClose={closeQuickContact}
                    />
                )}

                {showDetails && (
                    <ShopDetailsModal
                        shop={selectedShop}
                        onClose={() => setShowDetails(false)}
                        onSendFiles={() =>
                            navigate("/marketplace/upload", {
                                state: { selectedShop }
                            })
                        }
                        onQuickContact={() => {
                            closeMoreInfo();
                            openQuickContact(selectedShop);
                        }}
                    />
                )}



            </section>

            <Footer className="pb-[55px]" />

            <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#e4e5e7] z-20">
                <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[14px] flex items-center justify-between">
                    <div className="flex items-center gap-[12px] min-w-0">
                        {selectedShop ? (
                            <>
                                <div className="w-[40px] h-[40px] rounded-[10px] overflow-hidden shrink-0">
                                    <img src={selectedShop?.shopPhoto || `https://images.unsplash.com/photo-1767974785671-cfc4c8727147?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmludCUyMHNob3AlMjBzdG9yZWZyb250JTIwbW9kZXJufGVufDF8fHx8MTc3MjU2NDg3NHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral`}
                                        alt="" className="w-full h-full object-cover" />
                                </div>
                                <div className="min-w-0">
                                    <p className="font-semibold text-[14px] text-[#212326] truncate">{selectedShop.shopName}</p>
                                    <p className="font-medium text-[12px] text-[#717182] truncate">{fullAddress}</p>
                                </div>
                            </>
                        ) : (
                            <p className="font-medium text-[14px] text-[#9298a0]">Select a business to continue</p>
                        )}
                    </div>
                    <button
                        disabled={!selectedShop}
                        onClick={() => {
                            if (!selectedShop) return;
                            if (selectedShop.type === "printShop") {
                                navigate("/marketplace/upload", {
                                    state: { selectedShop }
                                });
                            } else {
                                setIsQuickContactOpen(true);
                            }
                        }}
                        className={`flex items-center gap-[8px] px-[20px] md:px-[28px] py-[12px] rounded-[10px] font-semibold text-[15px] transition-all shrink-0 ${selectedShop ? 'bg-[#ff5323] text-white hover:bg-[#e64a1f] shadow-[0px_2px_8px_rgba(255,83,35,0.3)]' : 'bg-[#e4e5e7] text-[#9298a0] cursor-not-allowed'}`}
                    >
                        Continue
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right w-[16px] h-[16px]">
                            <path d="M5 12h14">
                            </path>
                            <path d="m12 5 7 7-7 7"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SecretMarketPlace;
